export default "__VITE_ASSET__Smg3I2x___"